import experiment from 'experiment';
import { BasePublicApi } from '#packages/apilib';
import { StageContextScope } from './stageContextScope';

import type { StageContext } from './stageContextTypes';
import type { CompRef } from '@wix/document-services-types';

/**
 * @param scope
 * @param compRef
 *
 * Resolves a context for provided compRef.
 */
function getCurrentContextForRef(
  scope: StageContextScope,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  compRef: CompRef, //TODO: delete?
): StageContext {
  const { breakpointsApi } = scope;

  if (experiment.isOpen('se_mobileOverUnifiedStructure')) {
    const activeBreakpoint = breakpointsApi.getFocusedPageActiveBreakpoint();
    /*
     * responsiveLayout.get() returns undefined if no layout was explicitly set for specific variant. We plan
     * to make the feature when ALL desktop components will have layouts under desktop breakpoint. Until then,
     * we need to return no variants for desktop pointers in order not to break the desktop layout.
     */
    if (breakpointsApi.isDesktopBreakpointActive()) {
      return {};
    }

    return {
      variants: [activeBreakpoint.pointer],
    };
  }

  return {};
}

export class StageContextApi extends BasePublicApi<StageContextScope> {
  getCurrentContextForRef = this.bindScope(getCurrentContextForRef);
}
